// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: center;
    align-content: center;
    width: 100%;
    height: 100%;
  }
  
  .image {
    display: block;
    margin: 0 auto;
    width: 20%;
  }
  
  .button-center{
    align-self: center;
  }
  
  @media screen and (max-width: 576px) {
    .image {
      width: 30%;
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/app/core/errors/incorrect-configuration/incorrect-configuration.component.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,uBAAuB;IACvB,qBAAqB;IACrB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,cAAc;IACd,cAAc;IACd,UAAU;EACZ;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE;MACE,UAAU;IACZ;EACF","sourcesContent":[".container {\n    display: flex;\n    flex-direction: column;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-content: center;\n    width: 100%;\n    height: 100%;\n  }\n  \n  .image {\n    display: block;\n    margin: 0 auto;\n    width: 20%;\n  }\n  \n  .button-center{\n    align-self: center;\n  }\n  \n  @media screen and (max-width: 576px) {\n    .image {\n      width: 30%;\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
